//------------------------------------
// get specific rune integrated count
//------------------------------------
export default function getSpecificRuneIntegratedCount({ runes, target_rune }) {
  if (!runes || !target_rune) {
    console.error('getSpecificRuneIntegratedCount: missing required parms')
    return 0
  }

  return runes.filter((r) => r.name == target_rune.name && r.integrated).length
}
